module.exports = __webpack_public_path__ + "static/media/close.6d5a69b1.svg";